import AxiosStatic from 'axios';
import { GuardianInfo } from '../types/legal.types';
import { API_ENDPOINTS } from '../constants/api';
import axios from './client';

export interface GuardianApiResponse<T> {
    Status: string;
    data: T;
    status?: string;
}

export class LegalService {
    static async getGuardianInfo(): Promise<GuardianInfo> {
        try {
            const response = await axios.get<GuardianApiResponse<GuardianInfo>>(
                API_ENDPOINTS.GET_GUARDIAN_INFO
            );
            if (response.data.Status === 'OK') {
                return response.data.data;
            } else {
                throw new Error('Failed to get guardian info');
            }
        } catch (error) {
            if (AxiosStatic.isAxiosError(error)) {
                throw new Error(error?.response?.data?.errorCode);
            }
            throw new Error('Unknown error occurred');
        }
    }

    static async updateGuardianInfo(guardianData: GuardianInfo): Promise<GuardianInfo> {
        try {
            const response = await axios.post<GuardianApiResponse<GuardianInfo>>(
                API_ENDPOINTS.UPDATE_GUARDIAN_INFO,
                guardianData
            );
            if (response.data.status === 'OK') {
                return response.data.data;
            } else {
                throw new Error('Failed to update guardian info:');
            }
        } catch (error) {
            if (AxiosStatic.isAxiosError(error)) {
                throw new Error(error?.response?.data?.errorCode);
            }
            throw new Error('Unknown error occurred');
        }
    }
}
